@import '~less/global-variables';
@import '~less/layout/typography';

/**
 * Header
 */
#tr-header {
  .font-brand-regular();
  color: @navbar-default-color;
  background: @navbar-default-bg;
  min-height: @navbar-height;
  padding: 0;

  > .container {
    min-height: @navbar-height;
    justify-content: flex-start;
  }

  .navbar {
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  }

  .navbar-brand {
    padding-top: 6px;
  }

  .navbar-nav {
    flex-direction: row;
    align-items: center;
    margin-top: 0;
    margin-bottom: 0;
  }

  .navbar-nav {
    // Fix, because we don't have normal Bootstrap collapsable menu
    > li {
      float: left;
    }

    a {
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    }

    > li > a,
    > .dropdown > .dropdown-toggle {
      display: block;
      padding: 10px 12px;
      color: @navbar-default-link-color;
      text-decoration: none;
    }

    // Anchor the unread badge to its link, as Bootstrap 3 did for nav items.
    > li > a {
      position: relative;
    }

    > .dropdown > .dropdown-toggle {
      background: transparent;
      border: 0;
    }

    .dropdown-header {
      cursor: auto;
    }

    .dropdown-menu {
      a {
        text-shadow: none;
        &.active,
        &:active,
        &:focus {
          outline: none;
          color: @navbar-default-color;
          background: @brand-primary;
        }
      }
    }

    // Keep mobile icons legible against the green header.
    @media (max-width: @grid-float-breakpoint-max) {
      a {
        color: @navbar-default-link-color;
        text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.3);
        font-size: 18px;
      }
      > li.active a {
        color: #fff;
        text-shadow: none;
      }
    }
  }

  .nav-header-primary {
    margin-left: auto;

    > li > a:hover,
    > li > a:focus-visible {
      color: @navbar-default-link-hover-color;
      background: @navbar-default-link-hover-bg;
    }

    // Bootstrap 5 no longer colours an active item from the legacy li class.
    > li.active > a,
    > li.active > a:hover,
    > li.active > a:focus {
      color: @navbar-default-link-active-color;
      background: @navbar-default-link-active-bg;
    }

    @media (max-width: @grid-float-breakpoint-max) {
      margin-left: auto;
      display: flex;
      width: 100%;
      justify-content: space-between;

      > li:not(.hidden-xs) {
        flex: 1;
        text-align: center;
      }

      // The mobile icons are blocks, so text-align alone does not centre them.
      > li > a > .visible-xs-block {
        margin-inline: auto;
      }

      > li > a,
      > li > a:hover,
      > li > a:focus {
        color: @navbar-default-link-color;
      }
    }
  }

  /* Bootstrap dropdowns */
  @media (min-width: @grid-float-breakpoint) {
    .header-link-dropdown:focus-within .dropdown-menu {
      display: block;
    }

    // Bootstrap 5 adds a gap below the toggle. It breaks the hover path into
    // the menu, closing it before the pointer reaches the first item.
    .dropdown-menu {
      margin-top: 0;
    }

    /* Make Bootstrap dropdowns open at hover */
    .dropdown:hover,
    .dropdown:focus {
      &:not(.disable-hover-display) .dropdown-menu {
        display: block;
      }
    }

    /* Make sure avatar works as a dropdown handle */
    .dropdown-user {
      .dropdown-toggle {
        width: 73px;
        .avatar {
          float: left;
          margin-right: 8px;
        }
      }
    }
  }
}

/* Welcome-header for non-authenticated users */
.header-welcome {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 5px 0;

  .header-more-text,
  .header-welcome-text {
    font-size: 18px;
    .font-brand-light();
  }
  .header-more-text {
    font-size: 14px;

    &.btn-link {
      --bs-btn-color: @navbar-default-link-color;
      --bs-btn-hover-color: @navbar-default-link-hover-color;
      color: @navbar-default-link-color;
    }
  }
  .header-welcome-text,
  .btn {
    margin: 0 10px;
  }

  .flex-side {
    flex: 1;
  }

  .language-switch {
    display: flex;
    justify-content: flex-end;

    .dropdown-menu {
      margin-top: 5px;
      margin-right: 5px;
      min-width: 100%; // We'd like dropdown-menu to be similar size to button. But it's 10px wider.
    }
  }
}
